// Mock data for Ahmad Kassabieh's Portfolio

export const personalInfo = {
  name: "Ahmad Kassabieh",
  title: "Senior Mobile Engineer",
  subtitle: "Flutter • iOS • Fintech Specialist",
  tagline: "Building scalable mobile solutions for 30M+ users across MENA & Africa",
  bio: "Senior Mobile Engineer specializing in Flutter and iOS, with 6+ years building and maintaining large-scale fintech and digital banking applications serving 30M+ users across MENA and Africa. CSPO-accredited, focused on performance, architecture, and delivery in regulated environments.",
  location: "Beirut, Lebanon",
  email: "ahmadkassabieh@gmail.com",
  phone: "+96171215047",
  linkedin: "https://www.linkedin.com/in/ahmad-kassabieh",
  github: "https://github.com/AhmadKsb",
  profileImage: "https://images.unsplash.com/photo-1566837945700-30057527ade0?w=600",
  heroBackground: "https://images.unsplash.com/photo-1644088379091-d574269d422f?w=1920",
  aboutImage: "https://images.pexels.com/photos/159299/graphic-design-studio-tracfone-programming-html-159299.jpeg?w=800"
};

export const experience = [
  {
    id: 1,
    company: "Layer",
    position: "Senior Flutter Developer",
    duration: "May 2025 - Present",
    startDate: "2025-05",
    current: true,
    achievements: [
      "Refactored legacy Flutter modules into Clean Architecture, reducing crash rates",
      "Improved app startup time by profiling widget rebuilds and isolating heavy async operations",
      "Guided Flutter SDK upgrades across multiple production banking apps",
      "Built custom Cloudflare Turnstile widget for enhanced security",
      "Built shared component library reducing feature delivery time"
    ],
    technologies: ["Flutter", "Dart", "Clean Architecture", "Cloudflare", "Firebase"]
  },
  {
    id: 2,
    company: "SNB",
    position: "iOS Developer",
    duration: "Dec 2024 - May 2025",
    startDate: "2024-12",
    current: false,
    achievements: [
      "Developed production-grade iOS banking features using Swift",
      "Built responsive UIs using UIKit and SwiftUI following Apple HIG",
      "Ensured maintainable code through MVVM and SOLID principles",
      "Conducted unit and UI testing using XCTest and XCUITest",
      "Performance profiling using Instruments for CPU and memory optimization"
    ],
    technologies: ["Swift", "UIKit", "SwiftUI", "MVVM", "XCTest", "Instruments"]
  },
  {
    id: 3,
    company: "TLOBLE",
    position: "Frontend Team Lead",
    duration: "Sep 2023 - Dec 2024",
    startDate: "2023-09",
    current: false,
    achievements: [
      "Automated manual operational workflows, reducing costs by 20%",
      "Improved delivery efficiency through Scrum-based planning",
      "Introduced comprehensive testing, achieving 40% reduction in post-launch bugs",
      "Built and led cross-functional frontend team",
      "Standardized Cubit state management across the team"
    ],
    technologies: ["Flutter", "Cubit", "Scrum", "Testing", "Leadership"]
  },
  {
    id: 4,
    company: "Layer",
    position: "Mobile Team Lead",
    duration: "Jun 2022 - Jul 2023",
    startDate: "2022-06",
    current: false,
    achievements: [
      "Managed 2 teams of 5 developers delivering high-quality mobile apps",
      "Contributed to technical discovery for new mobile banking systems",
      "Developed reusable code libraries improving code quality",
      "Mentored developers through regular feedback and reviews",
      "Collaborated with product managers, UX designers, and QA testers"
    ],
    technologies: ["Flutter", "Team Management", "Architecture", "Mentoring"]
  },
  {
    id: 5,
    company: "Layer",
    position: "Flutter Developer",
    duration: "Jan 2020 - Jun 2022",
    startDate: "2020-01",
    current: false,
    achievements: [
      "Diagnosed and resolved performance bottlenecks using Flutter DevTools",
      "Created animation views using Lottie and Flare packages",
      "Implemented localization across multiple banking applications",
      "Integrated push notifications and Firebase Analytics",
      "Developed native Android/iOS plugins including AR functionality"
    ],
    technologies: ["Flutter", "Dart", "Firebase", "Lottie", "AR", "Native Plugins"]
  }
];

export const projects = [
  {
    id: 1,
    title: "WKBeast",
    category: "Mobile App",
    description: "Built WKBeast from scratch using Flutter, integrating Firebase for authentication and database management. Delivered an intuitive UI driving 100K+ downloads with 4.8 rating.",
    duration: "Sep 2021 - Nov 2023",
    technologies: ["Flutter", "Firebase", "Authentication", "Database"],
    metrics: [
      { icon: "Download", label: "Downloads", value: "100K+" },
      { icon: "Star", label: "Rating", value: "4.8" },
      { icon: "Users", label: "Users", value: "100K+" }
    ],
    image: "https://images.unsplash.com/photo-1551650975-87deedd944c3?w=800",
    link: "#"
  },
  {
    id: 2,
    title: "Stylish by Hazem",
    category: "Mobile App",
    description: "Built cross-platform scheduling app for barbershop using Flutter. Achieved 10K+ downloads and 4.7 rating across platforms.",
    duration: "Aug 2020 - Dec 2022",
    technologies: ["Flutter", "Cross-platform", "Scheduling", "UI/UX"],
    metrics: [
      { icon: "Download", label: "Downloads", value: "10K+" },
      { icon: "Star", label: "Rating", value: "4.7" },
      { icon: "Smartphone", label: "Platforms", value: "iOS & Android" }
    ],
    image: "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=800",
    link: "#"
  },
  {
    id: 3,
    title: "Red Cross Emergency Dispatch",
    category: "Enterprise App",
    description: "Collaborated with AKMO team to develop private Red Cross dispatching app that notifies members during emergencies with real-time location sharing.",
    duration: "Jan 2019 - May 2019",
    technologies: ["Real-time", "Location Services", "Push Notifications", "Emergency Response"],
    metrics: [
      { icon: "AlertCircle", label: "Impact", value: "Critical Response" },
      { icon: "Building", label: "Type", value: "Enterprise" },
      { icon: "Users", label: "Team", value: "4 members" }
    ],
    image: "https://images.unsplash.com/photo-1584036561566-baf8f5f1b144?w=800",
    link: "#"
  }
];

export const skills = {
  languages: [
    { name: "Dart", level: 95 },
    { name: "Swift", level: 90 },
    { name: "Kotlin", level: 80 },
    { name: "Java", level: 75 },
    { name: "Python", level: 70 }
  ],
  frameworks: [
    { name: "Flutter", level: 95 },
    { name: "SwiftUI", level: 85 },
    { name: "UIKit", level: 90 },
    { name: "Firebase", level: 90 },
    { name: "REST APIs", level: 95 }
  ],
  architecture: [
    { name: "MVVM", level: 95 },
    { name: "Clean Architecture", level: 90 },
    { name: "SOLID Principles", level: 90 },
    { name: "Design Patterns", level: 85 }
  ],
  tools: [
    { name: "Git", level: 95 },
    { name: "CI/CD", level: 85 },
    { name: "Flutter DevTools", level: 90 },
    { name: "Xcode Instruments", level: 85 },
    { name: "Jira", level: 90 }
  ]
};

export const education = [
  {
    id: 1,
    institution: "American University of Beirut",
    degree: "Bachelor of Science in Computer Science",
    location: "Beirut, Lebanon",
    duration: "Aug 2015 - May 2019",
    gpa: "3.7",
    highlights: [
      "GPA: 3.7/4.0",
      "Focus on Software Engineering and Mobile Development",
      "Completed Final Year Project on Emergency Response Systems"
    ]
  }
];

export const certifications = [
  {
    id: 1,
    name: "Certified Scrum Product Owner (CSPO)",
    issuer: "Scrum Alliance",
    year: "2024",
    icon: "Award"
  },
  {
    id: 2,
    name: "Ethical Hacking",
    issuer: "Udemy",
    year: "2020",
    icon: "Shield"
  },
  {
    id: 3,
    name: "Network Hacking - Intermediate to Advanced",
    issuer: "Udemy",
    year: "2020",
    icon: "Network"
  }
];

export const articles = [
  {
    id: 1,
    title: "Optimizing Flutter Performance in Banking Apps",
    excerpt: "Deep dive into performance optimization techniques for large-scale Flutter applications serving millions of users.",
    date: "2026-2-24",
    readTime: "8 min read",
    category: "Flutter",
    image: "https://images.pexels.com/photos/28428592/pexels-photo-28428592.jpeg?w=400"
  },
  {
    id: 2,
    title: "Clean Architecture in Mobile Development",
    excerpt: "How implementing Clean Architecture reduced crash rates and improved maintainability in production apps.",
    date: "2025-9-19",
    readTime: "10 min read",
    category: "Architecture",
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=400"
  },
  {
    id: 3,
    title: "From Developer to Team Lead: Lessons Learned",
    excerpt: "Key insights from leading mobile development teams in the fintech industry.",
    date: "2025-9-19",
    readTime: "6 min read",
    category: "Leadership",
    image: "https://images.pexels.com/photos/574070/pexels-photo-574070.jpeg?w=400"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    position: "Product Manager at Layer",
    content: "Ahmad's technical expertise and leadership transformed our mobile development process. His focus on clean architecture and performance optimization resulted in significantly improved app stability.",
    avatar: "https://i.pravatar.cc/150?img=5"
  },
  {
    id: 2,
    name: "Michael Chen",
    position: "CTO at TLOBLE",
    content: "Working with Ahmad was exceptional. He not only delivered high-quality code but also mentored the entire team, improving our development practices and reducing bugs by 40%.",
    avatar: "https://i.pravatar.cc/150?img=12"
  },
  {
    id: 3,
    name: "Fatima Al-Rashid",
    position: "Senior iOS Developer at SNB",
    content: "Ahmad's deep understanding of both Flutter and native iOS development is impressive. His code is clean, maintainable, and always follows best practices.",
    avatar: "https://i.pravatar.cc/150?img=9"
  }
];

export const stats = [
  { label: "Years Experience", value: "6+" },
  { label: "Users Served", value: "30M+" },
  { label: "Projects Completed", value: "50+" },
  { label: "Team Members Led", value: "10+" }
];